var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('partnerLink',{attrs:{"partners":_vm.partners,"programs":_vm.programs},on:{"getPartners":_vm.getPartners}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }